var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('download-hero'),_c('pazar-training'),_c('pazar-files'),_c('setup-tools'),_c('tablet-tools'),_c('support-tools'),_c('page-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }